import type { FC } from 'react';
import { lazy } from 'react';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import {
  useStorageServiceRoot,
  type StorageServiceRootRequest,
} from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useStorageLocationsPageParams } from 'src/pages/storage/locations-new/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const StorageLocationsRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <StorageLocationsOverviewNew storageServiceRoot={storageServiceRoot} />
  );
};

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageLocationsOverviewNew: FC<Props> = ({
  storageServiceRoot,
}) => {
  const pageParams = useStorageLocationsPageParams();

  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
  });

  if (!storageLocations.response) return <PageSpinner />;

  return <Page storageLocations={storageLocations} pageParams={pageParams} />;
};
